import { ICategory } from "api/interfaces/category-api.type";
import { BaseTierCategoryAggregation } from "api/interfaces/get-page-details/common/nested-pagecontent.type";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import Link from "next/link";
import { useRouter } from "next/router";
import { ReactNode } from "react";
import { b2bUrl } from "util/url/static-urls";
import { ArrowLeft } from "lucide-react";
import CategoryToggler from "../filter/product-filter/CategoryToggler";
import styles from "./category-tree-tier0.module.scss";

interface ICategoryTreeTier0Props {
  isActiveCategory: (pageTier: string, categoryName: string) => boolean;
  tier0: string;
  getPath: (item: BaseTierCategoryAggregation, category: ICategory) => ({href: string, asPath: string});
  setCategoryAggData: (filterKey: string, categoryIndex: any, childCategories: any) => void;
  setIsCategoryTreeClick: () => void;
  children: ReactNode
}

function CategoryTreeTier0(props: ICategoryTreeTier0Props) {
  const {
    children, tier0Item, isActiveCategory, tier0, getPath, setCategoryAggData, setIsCategoryTreeClick,
  } = props;

  const { asPath } = useRouter();
  const isShopByCategory = ["/all-parts", b2bUrl].includes(asPath);

  if (!isShopByCategory) {
    const { href, asPath: tier0AsPath } = getPath(tier0Item, { tier0: tier0Item.bucket });
    return (
      <>
        <div className={styles.tier0_container}>
          <Link href="/all-parts">

            <ArrowLeft size={20} strokeWidth={5} className="m-r-5 m-t-5" color="#1a4d7c" />

          </Link>
          <Link href={href} as={tier0AsPath}>

            <PAText
              bold
              fontSize={FONT_SIZE[3]}
              color="pa-blue"
              data-testid="category-tree-tier0"
            >
              {tier0Item.bucket}

            </PAText>

          </Link>
        </div>
        {children}
      </>
    );
  }

  return (
    <CategoryToggler
      key={tier0Item.bucket}
      isCategoryOpen={tier0Item.tier1s && tier0Item.tier1s.length > 0}
      activeCategory={isActiveCategory(tier0Item.pageType, tier0Item.bucket)}
      activeParent={tier0?.toLowerCase() === tier0Item.bucket.toLowerCase()}
      item={tier0Item}
      tier0={tier0Item.bucket}
      {...getPath(tier0Item, { tier0: tier0Item.bucket })}
      setCategoryAggData={(childCategories) => setCategoryAggData(childCategories)}
      setIsCategoryTreeClick={setIsCategoryTreeClick}
    >
      {children}
    </CategoryToggler>
  );
}

export default CategoryTreeTier0;
